export default __webpack_public_path__ + "7b7f36ddeb864387a77a3510a137ac1b.png";